const state = () => ({
  reportTypesList: [],
  reportTypesShare: [],
  consultantEmailExists: false,
});

const getters = {};

const actions = {};

const mutations = {
  updateReportTypesLists(state, data) {
    state.reportTypesList = [];
    state.reportTypesShare = [];
    for (let i = 0; i < data.types.length; i++) {
      if (data.types[i].value != "Screening")
        state.reportTypesList.push(data.types[i]);
      else {
        if (data.customerId == 2 && data.isVind)
          state.reportTypesList.push(data.types[i]);
      }
    }
    state.reportTypesShare = state.reportTypesList.filter(
      (option) => option.id !== 30,
    );
  },
  updateConsultantMailExists(state, val) {
    state.consultantEmailExists = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
